import React, { PropTypes } from 'react';
import classNames from 'classnames';

import './styles.scss';


const UserImage = ({ user, className }) => (
  <div className={classNames('profile-photo', className)} styleName='profile-photo'>
    { user && user.image ?
      <img
        src={user.image.thumbnail.url}
        srcSet={`${user.image.thumbnail.url} 1x, ${user.image.thumbnail.url2x} 2x`}
        width={user.image.thumbnail.width}
        height={user.image.thumbnail.height}
        alt={user.public_name}
      />
      :
      <div
        className='user-image-placeholder'
        styleName='placeholder'
      />
    }
  </div>
);

UserImage.propTypes = {
  className: PropTypes.string,
  user: PropTypes.shape({
    image: PropTypes.shape({
      thumbnail: PropTypes.shape({
        url: PropTypes.string,
        url2x: PropTypes.string,
      }),
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    public_name: PropTypes.string,
  }).isRequired,
};

UserImage.defaultProps = {
  className: null,
};

export default UserImage;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/UserImage/index.jsx